var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"industry"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("留言行业排行")])]),_c('data-list',{attrs:{"data":_vm.chartConf.data.rows,"columns":_vm.column,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }